import axios from 'axios';
import RestService from '../../helpers/RestService';
import { ajaxUrls } from '../../settings/routes';

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';


export async function getTrasheds() {
  try {
    const {data} = await axios.post('/trash/list');

    if(data.errcode == 200) {
      return data.questions;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}

export async function recoveryQuestion(id, values) {
  try {
    const {data} = await axios.post('/trash/recover', {que: JSON.stringify({id, ...values})});

    if(data.errcode == 200) {
      return data.questions;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}


export async function removeQuestion(id) {
  try {
    const {data} = await axios.post('/trash/remove', {que: JSON.stringify({id})});

    if(data.errcode == 200) {
      return data.questions;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Trashed/actions.js